export default __webpack_public_path__ + "static/media/image-block-thumbnail-dark.fbefe9c1.svg";